(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cgg-offers-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cgg-cart-offers')) {
    class CggCartOffers extends HTMLElement {
      static busy = false;
      connectedCallback() {
        this.querySelectorAll('[data-cgg-variant]').forEach(button => button.disabled = false);
        this.onclick = async event => {
          const button = event.target.closest('[data-cgg-variant]');
          if (!button || CggCartOffers.busy) return;
          event.preventDefault();
          CggCartOffers.busy = true;
          const controls = [...document.querySelectorAll('cgg-cart-offers button, button[name="checkout"]')];
          const previous = controls.map(control => control.disabled);
          controls.forEach(control => control.disabled = true);
          const status = this.querySelector('[role="status"]');
          status.textContent = this.dataset.working;
          const root = this.dataset.root.replace(/\/?$/, '/');
          const request = async (path, options = {}) => {
            const response = await fetch(root + path, { credentials:'same-origin', cache:'no-store', ...options });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || 'Cart update failed');
            return data;
          };
          try {
            const cart = await request('cart.js');
            const handle = button.dataset.cggHandle;
            const members = button.dataset.cggMembers.split(',').map(value => value.trim()).filter(Boolean);
            const map = {"relationship-bundle": ["gentle-confrontation-handbook", "the-shadow-work-journal-for-couples", "the-digital-boundary-blueprint"], "self-improvement-bundle": ["confidence-through-kinesthetics", "somatic-self-care"], "the-complete-relationship-bundle": ["gentle-confrontation-handbook", "the-shadow-work-journal-for-couples", "the-digital-boundary-blueprint", "the-attachment-code", "after-the-we", "love-translated", "relationship-bundle"], "the-complete-self-improvement-bundle": ["confidence-through-kinesthetics", "somatic-self-care", "the-overthinking-fix", "the-nice-trap", "unshakeable", "self-improvement-bundle"]};
            const covered = new Set(cart.items.flatMap(item => [item.handle, ...(map[item.handle] || [])]));
            if (covered.has(handle)) { window.location.assign(this.dataset.cartUrl); return; }
            const replaced = cart.items.filter(item => members.includes(item.handle));
            if (members.length && (!replaced.length || replaced.some(item => item.quantity !== 1 || Object.keys(item.properties || {}).length || item.selling_plan_allocation))) {
              window.location.assign(this.dataset.cartUrl); return;
            }
            const updates = { [button.dataset.cggVariant]:1 };
            replaced.forEach(item => updates[item.key] = 0);
            const updated = await request('cart/update.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({updates}) });
            if (!updated.items.some(item => item.handle === handle) || updated.items.some(item => members.includes(item.handle))) throw new Error('Check cart');
            window.location.assign(this.dataset.cartUrl);
          } catch (error) {
            status.textContent = this.dataset.error;
            const link = document.createElement('a');
            link.href = this.dataset.cartUrl;
            link.textContent = this.dataset.cartLabel;
            status.append(' ', link);
            controls.forEach((control, index) => control.disabled = previous[index]);
            CggCartOffers.busy = false;
          }
        };
      }
    }
    customElements.define('cgg-cart-offers', CggCartOffers);
  }
  } catch(e) { console.error(e); }
})();

})();
